export default "__VITE_ASSET__UBGmKVSi__"